import { z } from 'zod';

import { zodDate, zodDatetime } from '../../utils/zodHelpers';
import { qhpSimpleSchema } from './basicSchemas';

const visitChangeStringSchema = z.object({
    old_value: z.string(),
    new_value: z.string(),
    value_type: z.literal('string'),
});
const visitChangeDatetimeSchema = z.object({
    old_value: zodDatetime().nullable(),
    new_value: zodDatetime().nullable(),
    value_type: z.literal('datetime'),
});
const visitChangeDateSchema = z.object({
    old_value: zodDate().nullable(),
    new_value: zodDate().nullable(),
    value_type: z.literal('date'),
});
export const visitChangeAssigneeSchema = z.object({
    old_value: qhpSimpleSchema.nullable(),
    new_value: qhpSimpleSchema.nullable(),
    value_type: z.literal('assignee'),
});
export const visitChangeIntSchema = z.object({
    old_value: z.number().nullable(),
    new_value: z.number().nullable(),
    value_type: z.literal('int'),
});
export const visitChangeSchema = z.object({
    changed_at: zodDatetime(),
    changed_by: z.string().nullable(),
    key_name: z.string(),
    value: z.union([
        visitChangeStringSchema,
        visitChangeDatetimeSchema,
        visitChangeDateSchema,
        visitChangeAssigneeSchema,
        visitChangeIntSchema,
    ]),
});
export type VisitChange = z.infer<typeof visitChangeSchema>;
